import AccessTokenRepository from '@/repositories/AccessTokenRepository'
import createAccessToken from '@/entities/AccessToken'
import createCurrentUser from '@/entities/CurrentUser'
import { createProvider } from '@/utils/vue-apollo'
import { SIGN_IN, CURRENT_USER } from '@/graphql'

const apollo = createProvider().defaultClient

const state = {
  currentUser: null,
  accessToken: AccessTokenRepository.load(),
}

const getters = {
  currentUser(state) {
    return state.currentUser
  },
  isLoggedIn(state) {
    return !!state.currentUser
  },
  isValidToken(state) {
    return state.accessToken && !state.accessToken.isExpired
  },
  validToken(state, getters) {
    if (!getters.isValidToken) {
      return
    }
    return state.accessToken.token
  },
}

const mutations = {
  START(state, user) {
    state.currentUser = user
  },
  LOGOUT(state) {
    state.credential = null
    state.currentUser = null
    state.accessToken = undefined
    AccessTokenRepository.remove()
  },
  UPDATE_ACCESS_TOKEN(state, accessToken) {
    state.accessToken = accessToken
    AccessTokenRepository.store(accessToken)
  },
}

const actions = {
  async login({ commit, dispatch }, { email, password }) {
    const variables = { email, password }
    const result = await apollo.mutate(SIGN_IN(variables))
    const accessToken = createAccessToken(result.data.signIn)
    commit('UPDATE_ACCESS_TOKEN', accessToken)
    await dispatch('getCurrentUser')
  },
  async logout({ commit }) {
    commit('LOGOUT')
  },
  async getCurrentUser({ getters, commit }) {
    if (getters.isLoggedIn || !getters.isValidToken) {
      return
    }

    const result = await apollo.query({
      query: CURRENT_USER,
      fetchPolicy: 'no-cache',
    })
    const currentUser = createCurrentUser(result.data.currentUser)
    commit('START', currentUser)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
